import './footerPaymentCards.scss';

import React, { FunctionComponent } from 'react';

import americanImg from '../../../images/payment/american-express-trasparency.svg';
import mastercardImg from '../../../images/payment/mastercard-Logo-transparency.svg';
import visaImg from '../../../images/payment/visa.svg';

type FooterPaymentCardsProps = {
    mobile?: boolean;
};

export const FooterPaymentCards: FunctionComponent<FooterPaymentCardsProps> = (
    props: FooterPaymentCardsProps
) => {
    const { mobile } = props;

    return (
        <div
            className={`payment-cards-footer ${
                mobile !== undefined ? 'mobile' : ''
            }`}
        >
            <img className='visa' src={visaImg} alt='' />
            <img className='mc' src={mastercardImg} alt='' />
            <img className='ae' src={americanImg} alt='' />
        </div>
    );
};
